






















import { Vue, Component } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import { detect } from 'detect-browser'
import Sidebar from './components/Sidebar.vue'
import Topbar from './components/Topbar.vue'
import Bottombar from './components/Bottombar.vue'
import { Point } from './model/models'

import main from './main'

@Component({ components: { Sidebar, Topbar, Bottombar },
  computed: mapGetters([
  ])
})
export default class App extends Vue {
  title = ' FoodVoc'
  height = 800

  mounted () {
    window.addEventListener('resize', this.handleResize)
    this.height = document.body.clientHeight - 70
    const browser = detect()
    // handle the case where we don't detect the browser
    if (browser) {
      console.log(browser.name)
      console.log(browser.version)
    }
    this.$nextTick(function () {
      main.store.commit('browserName', browser.name)
    })
  }
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  }
  handleResize (event:any) {
    var h = document.body.clientHeight
    var w = document.body.clientWidth
    console.log(h)
    this.height = h - 70
    var p = new Point(w, h)
    main.store.commit('windowSize', p)
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue